// Shown to staff whose browser cannot draw the interface. Inline styles only:
// this browser is exactly the one that cannot render the app's stylesheet.
const page = {
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "24px",
  background: "#f6f4ef",
  color: "#1d2230",
  fontFamily: "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
};

const card = {
  maxWidth: "440px",
  background: "#ffffff",
  border: "1px solid #e2ddd2",
  borderRadius: "12px",
  padding: "28px",
  lineHeight: 1.5,
};

export default function UnsupportedBrowser() {
  return (
    <div style={page}>
      <div style={card}>
        <h1 style={{ fontSize: "20px", margin: "0 0 12px" }}>Tarayıcınızı güncelleyin</h1>
        <p style={{ margin: "0 0 12px" }}>
          Domera bu tarayıcıda açılamıyor. Tarayıcıyı ya da cihazın işletim sistemini güncelledikten sonra
          sayfayı yenileyin.
        </p>
        <p style={{ margin: 0, color: "#5b6170" }}>
          Gereken en düşük sürümler: Chrome 111, Safari 16.4 (iPhone ve iPad'de iOS 16.4), Firefox 128.
        </p>
      </div>
    </div>
  );
}
